/*
* @providesModule ComponentStyles
*/

import SkillzStyle from "SkillzStyle";
import Sizes from 'Sizes';

const {
  viewCornerRadiusPrimary,
  viewPrimaryColor,
  viewSecondaryColor,
  btnGradientOne,
  btnGradientTwo,
  btnTextColorOne,
  btnTextColorTwo,
  fontBold,
  fontPrimary,
  fontRegular,
  fontSecondary,
  fontSizeH5,
  fontSizeH4,
  fontSizeH3,
  fontSizeH2,
  fontSizeH1,
  fontSizeExtraLarge,
  fontSizeVeryLarge,
  fontSizeLarge,
  textColorSecondary,
  textColorPrimary,
  textColorCash,
  textColorDepositTile,
  textCashGradient,
  opacityTertiary,
} = SkillzStyle.fullStyles;

const NoThemeStyleItems = {
  btnTextShadow: {
    shadowColor:"#000000",
    shadowOffset:{
      width:0,
      height:2
    },
    shadowRadius:1,
    shadowOpacity:0.2
  },
  btnDropShadow: {
    shadowColor:"#000000",
    shadowOffset:{
      width:0,
      height:2
    },
    shadowRadius:1,
    shadowOpacity:0.2
  },
  fontButton1Shadow: {
    shadowColor:"#000000",
    shadowOffset:{
      width:0,
      height:2
    },
    shadowRadius:1,
    shadowOpacity:0.2
  },
  containerCornerRadius1: {
    borderRadius:Sizes.dynamic({
      phone: 3,
      tablet: 6
    }),
  },
  containerDropShadow1: {
    shadowColor:"#000000",
    shadowOffset:{
      width:0,
      height:3
    },
    shadowRadius:1,
    shadowOpacity:0.2
  },
};

const ComponentFonts = {
  fontLight1: {
    ...fontPrimary,
    ...fontSizeH4,
    ...textColorSecondary,
  },
  fontLight2: {
    ...fontPrimary,
    ...fontSizeH2,
    ...textColorSecondary,
  },
  fontLight3: {
    ...fontPrimary,
    ...Sizes.dynamic({
      phone: fontSizeH4,
      tablet: fontSizeH2
    }),
    ...textColorPrimary,
  },
  fontLight4: {
    ...fontPrimary,
    ...fontSizeH3,
    ...textColorSecondary
  },
  fontLight5: {
    ...fontPrimary,
    ...fontSizeH5,
    ...textColorSecondary
  },
  fontLight6: {
    ...fontSecondary,
    ...Sizes.dynamic({
      phone: fontSizeH3,
      tablet: fontSizeH2
    }),
    ...btnTextColorTwo   
  },

  fontRegular1: {
    ...fontRegular,
    ...fontSizeH1,
    ...textColorSecondary
  },
  fontRegular2: {
    ...fontRegular,
    ...fontSizeH3,
    ...textColorSecondary
  },
  fontBoldCash: {
    ...fontSecondary,
    ...fontSizeH1,
    ...textColorCash,
  },
  fontBold1: {
    ...fontBold,
    ...fontSizeH2,
    ...textColorSecondary,
  },
  fontBold2: {
    ...fontSecondary,
    ...fontSizeExtraLarge,
    ...textColorDepositTile,
  },
  fontBold3: {
    ...fontSecondary,
    ...fontSizeH1,
    ...textColorDepositTile,
  },
  fontBold4: {
    ...fontBold,
    ...fontSizeLarge,
    ...textColorDepositTile,
  },
  fontBold5: {
    ...fontSecondary,
    ...fontSizeVeryLarge,
    ...textColorDepositTile,
  },
  fontBold6: {
    ...fontSecondary,
    ...fontSizeH3,
    ...textColorCash,
  },
  fontButton1: {
    ...NoThemeStyleItems.fontButton1Shadow,
    ...fontSecondary,
    ...fontSizeH1,
    ...btnTextColorOne,
  },
};

const ComponentStyles = {
  primaryCTA: {
    ...NoThemeStyleItems.btnTextShadow,
    ...NoThemeStyleItems.btnDropShadow,
    ...viewCornerRadiusPrimary,
    ...btnGradientOne,
    ...ComponentFonts.fontButton1,
  },
  secondaryCTA: {
    ...viewCornerRadiusPrimary,
    ...btnGradientTwo,
    ...ComponentFonts.fontButton1,
    ...NoThemeStyleItems.btnTextShadow,
    ...NoThemeStyleItems.btnDropShadow,
  },

  depositTile1: {
    ...NoThemeStyleItems.containerDropShadow1,
    ...NoThemeStyleItems.containerCornerRadius1,
    ...textCashGradient,
  },

  container1: {
    ...NoThemeStyleItems.containerCornerRadius1,
    ...viewSecondaryColor,
  },
  container2: {
    ...NoThemeStyleItems.containerCornerRadius1,
    backgroundColor: SkillzStyle.convertToOpacity(viewPrimaryColor.backgroundColor, opacityTertiary),
  },
};

export {ComponentStyles as default, ComponentFonts, NoThemeStyleItems};
